/**
 * Módulos contratados por un cliente.
 *
 * El documento del cliente trae un arreglo `modules` con los módulos de la plataforma que tiene
 * habilitados. Cada aplicación revisa el suyo: si no aparece, el cliente lo dio de baja y la
 * aplicación no debe operar para ese cliente.
 */

/** Módulo que habilita este proyecto, el tótem de autoatención. */
export const SELF_ORDERING_KIOSK_MODULE = 'self-ordering-kiosk';

/** Impresión de boletas por USB mediante la app Printer Bridge; sin él, el asistente omite ese paso. */
export const PRINTER_BRIDGE_MODULE = 'printer-bridge';

/**
 * Indica si el cliente tiene habilitado un módulo.
 *
 * Ante la duda responde que no: un documento que todavía no llega, que no existe, o que trae un
 * `modules` con una forma inesperada, deja el tótem fuera de servicio en lugar de dejarlo vender
 * algo que el cliente no tiene contratado.
 *
 * @param {Object|null} clientData - Documento del cliente.
 * @param {string} moduleName - Módulo a buscar.
 * @returns {boolean}
 */
export function hasModule(clientData, moduleName) {
  const modules = clientData?.modules;
  if (!Array.isArray(modules)) return false;
  return modules.includes(moduleName);
}
